import {ClimbingEvent} from "../../../models/ClimbingEvent";
import {FC, useEffect, useState} from "react";
import {getSimplifiedResults} from "../../../services/events/EventSimplifiedResultService";
import {ClimbingEventSimplifiedResults} from "../../../models/ClimbingEventSimplifiedResults";
import {Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel} from "@mui/material";
import {SortDirection} from "@mui/material/TableCell/TableCell";
import {useTranslation} from "react-i18next";

type Props = {
    climbingEvent: ClimbingEvent
}

type RouteStats = {
    id: number,
    nrOfClimbs: number,
    favorite: number
}

export const StatisticsComponent: FC<Props> = ({
                                                   climbingEvent
                                               }) => {
    const [routeStats, setRouteStats] = useState<RouteStats[]>([])
    const [sorting, setSorting] = useState<'nrOfClimbs' | 'favorite' | 'id'>('favorite')
    const [order, setOrder] = useState<SortDirection>('desc');
    const [sortedRoutes, setSortedRoutes] = useState<RouteStats[]>([])
    const {t} = useTranslation();

    useEffect(() => {
        setSortedRoutes(routeStats.sort((a, b) => {
            if (sorting === 'id') {
                return order === 'asc' ? a.id - b.id : b.id - a.id;
            } else if (sorting === 'nrOfClimbs') {
                return order === 'asc' ? a.nrOfClimbs - b.nrOfClimbs : b.nrOfClimbs - a.nrOfClimbs;
            } else {
                return order === 'asc' ? a.favorite - b.favorite : b.favorite - a.favorite;
            }
        }))
    }, [routeStats, sorting, order]);

    function calculateRouteStats(results: ClimbingEventSimplifiedResults[]): RouteStats[] {

        const simplifiedResults = results
            .flatMap(result => Array.from(result.userSumOfPoints.values()))

        const routeStatsArray: RouteStats[] = [];
        for (const [id, nrOfClimbs] of climbingEvent.routesToNrOfClimbes.entries()) {
            const favorite = simplifiedResults.filter(r => r.favoriteRoute === id).length;
            routeStatsArray.push({
                id,
                nrOfClimbs,
                favorite: favorite,
            });
        }
        return routeStatsArray;
    }

    const handleRequestSort = (
        property: 'nrOfClimbs' | 'favorite' | 'id',
    ) => {
        console.log("clicked", property)
        if(property === sorting) {
            setOrder(order === 'asc' ? 'desc' : 'asc');
        }else{
            setSorting(property);
        }
    };

    useEffect(() => {
        getSimplifiedResults(climbingEvent.name).then((results) => {
            setRouteStats(calculateRouteStats(results))
        })
    }, [climbingEvent])

    console.log(sortedRoutes)
    return (
        <Box display={'flex'} flexDirection={"column"} gap={2}>
            <Paper sx={{width: '90lvw', overflow: 'hidden', m: 2}}>
                <Table sx={{width: '100%'}} aria-label={'results.label'}>
                    <TableHead>
                        <TableCell
                            key={"id"}
                            id={"header_id"}
                            sortDirection={sorting === "id" ? order : false}
                            onClick={() => {
                                handleRequestSort('id')
                            }}>
                            <TableSortLabel
                                active={sorting === "id"}
                                direction={order === "desc" ? "desc" : "asc"}

                            >
                                {t('results.route')}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            key={"nrOfClimbs"}
                            sortDirection={sorting === "nrOfClimbs" ? order : false}>
                            <TableSortLabel
                                active={sorting === "nrOfClimbs"}
                                direction={order === "desc" ? "desc" : "asc"}
                                onClick={() => {
                                    handleRequestSort('nrOfClimbs')
                                }}
                            >
                                {t('results.nrOfClimbs')}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            key={"favorite"}
                            sortDirection={sorting === "favorite" ? order : false}>
                            <TableSortLabel
                                active={sorting === "favorite"}
                                direction={order === "desc" ? "desc" : "asc"}
                                onClick={() => {
                                    handleRequestSort('favorite')
                                }}
                            >
                                {t('results.nrOfFavorites')}
                            </TableSortLabel>
                        </TableCell>
                    </TableHead>
                    <TableBody>
                        {sortedRoutes.map((routeStat) => (
                            <TableRow id={"row__"+routeStat.id} key={routeStat.id}>
                                <TableCell key={routeStat.id}>
                                    {routeStat.id}
                                </TableCell>
                                <TableCell key={routeStat.nrOfClimbs}>
                                    {routeStat.nrOfClimbs}
                                </TableCell>
                                <TableCell key={routeStat.favorite}>
                                    {routeStat.favorite}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    )

}
